var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.frontpage = {
	init: function() {

	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	//site.svg.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
